import * as Yup from 'yup'

export const multiUserCrewSchema = [
  Yup.object({
  }),
  Yup.object({
  }),
  Yup.object({
    CampamentoId: Yup.string().required('Campamento es requerido').label('Campamento'),
    ProgramacionServicioId: Yup.string().required('Programación de Servicio es requerido').label('Programación de Servicio'),
    FechaInicio: Yup.string().required('Fecha de Inicio es requerido').label('Fecha de Inicio'),
    FechaFin: Yup.string().required('Fecha de Fin es requerido').label('Fecha de Fin'),
  }),
  Yup.object({}),
  Yup.object({}),
]

export const manualScanCensusSchema = Yup.object({
  ActividadId: Yup.string().required('Actividad de Limpieza es requerida').label('Actividad de Limpieza'),
})